import { Asset } from '~/utils/metadata';
import { getPlayerManager } from '~/cast/lib';
import { getMediaMetadata } from './utils';

export function updateVodMediaMetadata(asset: Asset) {
  const player = getPlayerManager();

  const mediaInformation =
    player.getMediaInformation() ??
    new cast.framework.messages.MediaInformation();

  if (!mediaInformation.customData) {
    // Border case when the media information is not set yet
    mediaInformation.customData = {
      assetId: asset.vrioAssetId || '',
      vmsId: asset.vmsId || '',
      assetType: asset.type || '',
      isLive: false,
      mainAssetId: '',
      playSource: '',
      senderName: '',
      senderVersion: '',
      actionOrigin: '',
      userOrigin: {
        msoProvider: '',
        playSource: '',
        userLogin: '',
      },
    };
  }

  const { customData } = mediaInformation;
  customData.asset = asset;
  customData.isLive = false;

  const mediaMetadata = getMediaMetadata(asset);
  mediaInformation.metadata = mediaMetadata;

  player.setMediaInformation(mediaInformation);

  return asset;
}
